
export default {
  props: {
    color: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: String,
      required: false,
      default: '32'
    }
  },

  computed: {

    /**
     * getWrapperClass
     * @return {string}
     */
    getWrapperClass () {
      if (this.color) {
        return `spinner--${this.color}`
      }
    },

    /**
     * getLoaderSize
     * @return {string}
     */
    getLoaderSize () {
      return `${this.size}px`
    }
  }
}
